var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3-field',{class:{'vertical': _vm.layoutType},attrs:{"readOnly":true,"showIcon":false,"label":_vm.label,"labelStyle":_vm.styleObj}},[_c('div',{class:{'field__control' : !_vm.readonly}},[_vm._v("\n    "+_vm._s(_vm.text)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }